import { Box, Flex, Text } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { Badge, Banner, ButtonText } from '@morressier/alembic';
import { IPeerReviewListItem } from '@publishing-engine/domain/views';
import { formatDate } from 'src/utils/date';
import { Overlay } from '../Overlay';
import { Layout } from '../Layout';

type Props = {
  onClose: () => void;
  review: IPeerReviewListItem;
};

export const DeclineReviewAdditionalInformation: React.FC<Props> = ({
  review,
  onClose
}) => {
  const declinedReviewCompletionDate = review.workflow.dateEnteredCurrentPhase;

  const nameOrEmail = review.reviewer.firstName
    ? `${review.reviewer.firstName} ${review.reviewer.lastName}`
    : review.reviewer.email;

  const formattedDate = declinedReviewCompletionDate
    ? formatDate(new Date(declinedReviewCompletionDate))
    : 'N/A';

  const { additionalInformation } = review.caseData;

  return (
    <Overlay>
      <Flex flexDirection="column" backgroundColor="surfaceSecondaryFill">
        <Layout width="48rem">
          <Flex gap={8} flexDirection="column">
            <ButtonText
              leftIcon={<FontAwesomeIcon icon={faArrowLeft} />}
              maxWidth="fit-content"
              onClick={onClose}
              variant="secondary"
            >
              Back to Reviews
            </ButtonText>
            <Flex gap={2} flexDirection="column">
              <Box>
                <Badge variant="neutral" size="context">
                  Review
                </Badge>
              </Box>
              <Text textStyle="headingTitle">Declined Review</Text>
              <Text>{`by ${nameOrEmail}, on ${formattedDate}`}</Text>
            </Flex>
            <Banner
              content="This Reviewer has left additional information along with their decision to decline the review invitation."
              heading="For your attention"
              variant="attention"
            />
            <Flex flexDirection="column" gap={2}>
              <Text textStyle="headingItem">Reason for Declining</Text>
              <Text textStyle="textBody">
                {additionalInformation?.declineReason}
              </Text>
            </Flex>
            {additionalInformation?.recommendedReviewers &&
            additionalInformation?.recommendedReviewers.length > 0 ? (
              <Flex flexDirection="column" gap={2}>
                <Text textStyle="headingItem">Recommended Reviewers</Text>
                <Flex flexDirection="column">
                  {additionalInformation?.recommendedReviewers?.map(email => {
                    return (
                      <Flex
                        padding={4}
                        justifyContent="space-between"
                        backgroundColor="surfacePrimaryFill"
                        borderBottom="1px"
                        borderBottomColor="neutralPrimaryBorder"
                      >
                        <Text textStyle="textBody">{email}</Text>
                      </Flex>
                    );
                  })}
                </Flex>
              </Flex>
            ) : null}
          </Flex>
        </Layout>
      </Flex>
    </Overlay>
  );
};
